export function formatScore(score: number): string {
  return score.toFixed(1);
}

export function percentileLabel(score: number, allScores: number[]): string {
  if (allScores.length <= 1) return '';
  const sorted = [...allScores].sort((a, b) => b - a);
  const rank = sorted.indexOf(score);
  if (rank === -1) return '';

  // For small sessions, show rank instead of misleading percentile
  if (allScores.length < 5) {
    return `#${rank + 1} of ${sorted.length}`;
  }

  // rank 0 = best photo → "Top 1%", rank N-1 = worst → hidden
  const pct = Math.max(1, Math.round((rank / (sorted.length - 1)) * 100));
  if (pct > 80) return ''; // Don't show discouraging labels for bottom tier
  if (pct <= 1) return `Top photo of ${sorted.length}`;
  return `Top ${pct}% of ${sorted.length} photos`;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}
